import { render, staticRenderFns } from "./password-login.vue?vue&type=template&id=573a63c4"
import script from "./password-login.vue?vue&type=script&lang=js"
export * from "./password-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/login/password-login.vue
// module id = +W3J
// module chunks = 0